import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    this.poll = this.poll.bind(this)
    if (this.active()) this.timer = window.setInterval(this.poll, this.intervalValue)
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  async poll() {
    if (!this.active()) return this.disconnect()

    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/html" },
        credentials: "same-origin"
      })
      if (!response.ok) return

      const html = await response.text()
      const documentFragment = new DOMParser().parseFromString(html, "text/html")
      const replacement = documentFragment.getElementById("assistant_evaluation_run")
      if (replacement) this.element.outerHTML = replacement.outerHTML
    } catch (_error) {
      // Leave the current progress state visible and try again on the next interval.
    }
  }

  active() {
    return this.element.dataset.evaluationActive === "true"
  }
}
